import React, { useState, useEffect } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link, useLocation } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import { CgSun } from "react-icons/cg/";
import { HiMoon } from "react-icons/hi";

function Header(props) {
  const theme = props.theme;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Using useLocation to track the current route
  const location = useLocation();

  // Determine which page's color scheme to use based on current path
  const getLogoClass = () => {
    const path = location.pathname;

    if (path.includes("/education")) return "education-logo";
    if (path.includes("/experience")) return "experience-logo";
    if (path.includes("/projects")) return "projects-logo";
    if (path.includes("/contact")) return "contact-logo";
    // Default to home color scheme
    return "home-logo";
  };

  const link = settings.isSplash ? "/splash" : "/home";

  const [currTheme, setCurrTheme] = useState(props.theme);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      const header = document.querySelector(".header");
      const menuBtn = document.querySelector(".menu-btn");

      if (
        isMenuOpen &&
        header &&
        !header.contains(event.target) &&
        menuBtn &&
        !menuBtn.checked
      ) {
        setIsMenuOpen(false);
      }
    }

    // Close menu when route changes or screen size changes
    function handleResize() {
      if (window.innerWidth > 768 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMenuOpen]);

  function changeTheme() {
    if (currTheme === "light") {
      props.setTheme("dark");
      localStorage.setItem("theme", "dark");
      setCurrTheme("dark");
    } else {
      props.setTheme("light");
      localStorage.setItem("theme", "light");
      setCurrTheme("light");
    }
  }

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <Fade top duration={1000} distance="20px">
      <div>
        <header className="header">
          <Link
            to={link}
            className={`logo ${getLogoClass()}`}
            onClick={closeMenu}
          >
            <span style={{ color: theme.text }}></span>
            <span
              className="logo-name"
              style={{ color: theme.text }}
              dangerouslySetInnerHTML={{ __html: greeting.logo_name }}
            ></span>
            <span style={{ color: theme.text }}></span>
          </Link>
          <input
            className="menu-btn"
            type="checkbox"
            id="menu-btn"
            checked={isMenuOpen}
            onChange={handleMenuToggle}
          />
          <label
            className="menu-icon"
            htmlFor="menu-btn"
            tabIndex="0"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleMenuToggle();
                e.preventDefault();
              }
            }}
          >
            <span className="navicon"></span>
          </label>
          <ul className={`menu ${isMenuOpen ? "open" : ""}`}>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "homei active" : "homei"
                }
                to="/home"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                  borderRadius: 5,
                  color: theme.text,
                })}
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "ec active" : "ec")}
                to="/education"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                  borderRadius: 5,
                  color: theme.text,
                })}
                onClick={closeMenu}
              >
                Education
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "xp active" : "xp")}
                to="/experience"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                  borderRadius: 5,
                  color: theme.text,
                })}
                onClick={closeMenu}
              >
                Experience
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "projects active" : "projects"
                }
                to="/projects"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                  borderRadius: 5,
                  color: theme.text,
                })}
                onClick={closeMenu}
              >
                Projects
              </NavLink>
            </li>
            <li>
              <a
                className="blog"
                href="https://blog.vijaybalaji.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  borderRadius: 5,
                  color: theme.text,
                }}
                onClick={closeMenu}
              >
                Blog
              </a>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "cr active" : "cr")}
                to="/contact"
                style={({ isActive }) => ({
                  fontWeight: isActive ? "bold" : "normal",
                  borderRadius: 5,
                  color: theme.text,
                })}
                onClick={closeMenu}
              >
                Contact me
              </NavLink>
            </li>

            <li className="theme-toggle-item">
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={changeTheme}
                  checked={theme.name === "dark"}
                />
                <span className="slider round">
                  <span className="sun-icon">
                    <CgSun size={18} />
                  </span>
                  <span className="moon-icon">
                    <HiMoon size={18} />
                  </span>
                </span>
              </label>
            </li>
          </ul>
        </header>
      </div>
    </Fade>
  );
}

export default Header;
